export default __webpack_public_path__ + "static/media/food4.2da6501a.jpg";